import { CCard, CCardBody } from "@coreui/react-pro";
import CIcon from "@coreui/icons-react";
import { cilEnvelopeClosed } from "@coreui/icons";

// MVP-grade contact page: an email address, nothing more. No form, no
// ticketing — keeps the surface area small until we know what real
// support volume looks like.
const SUPPORT_EMAIL = "help@scryerlabs.com";

export function Contact() {
  return (
    <div>
      <h1 className="mb-2">Contact us</h1>
      <p className="text-body-secondary mb-4" style={{ maxWidth: 720 }}>
        Questions or billing issues? Drop us an email and we'll get back to
        you.
      </p>

      <CCard>
        <CCardBody className="d-flex flex-wrap align-items-center justify-content-between gap-4">
          <div className="d-flex align-items-start gap-3" style={{ maxWidth: 620 }}>
            <div
              className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary-subtle text-primary flex-shrink-0"
              style={{ width: 48, height: 48 }}
            >
              <CIcon icon={cilEnvelopeClosed} size="lg" />
            </div>
            <div>
              <h5 className="mb-1">Email</h5>
              <p className="text-body-secondary mb-0">
                For account and billing questions. We aim to reply within one
                business day.
              </p>
            </div>
          </div>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="btn btn-primary">
            {SUPPORT_EMAIL}
          </a>
        </CCardBody>
      </CCard>
    </div>
  );
}
